export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-trip-progress-960-1a55e8f69e32cb0b7d9fc9cdeaeb1fc0.png";